import { Box } from '@mui/material';
import * as React from 'react';
import GridLayout from 'react-grid-layout';

import { AdminWorkspaceRoles } from '~/data/user/role';
import {
  MyWorkspaceWidgetNames,
  myWorkspaceWidgetsMap,
} from '~/scenes/MyWorkspace/components/Widgets/data';
import { RoleGroups } from '~/services/Permissions';

import { useWidgetsLayout } from './useWidgetsLayout';

export type WidgetsLayoutWidgetProps = {
  widgetName: MyWorkspaceWidgetNames;
  roleGroup: RoleGroups;
  role: AdminWorkspaceRoles;
  config?: object;
};

export type WidgetsLayoutProps = {
  widgets: WidgetsLayoutWidgetProps[];
};
export const WidgetsLayout = (props: WidgetsLayoutProps) => {
  const widgetsLayout = useWidgetsLayout(props);
  const { containerRef, layoutData, gridLayoutProps, calculateWidgetWidth } =
    widgetsLayout;

  return (
    <Box ref={containerRef}>
      <GridLayout
        {...gridLayoutProps}
        compactType="horizontal"
        useCSSTransforms={true}
        isDraggable={false}
        isDroppable={false}
        isResizable={false}
      >
        {layoutData?.layout.map(({ i, w }) => {
          const widgetSettings = layoutData?.settings[i];
          const widget = myWorkspaceWidgetsMap[widgetSettings.widget];

          if (!widget) {
            throw new Error(
              `Widget "${widgetSettings.widget}" is not registered!`,
            );
          }

          return (
            <Box
              key={widgetSettings.id}
              sx={{
                position: 'relative',

                '& > *:not($widget)': {
                  zIndex: 2,
                },
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                }}
              >
                {React.createElement(widget.component, {
                  title: widgetSettings.title,
                  config: widgetSettings.config,
                  width: calculateWidgetWidth(w),
                })}
              </Box>
            </Box>
          );
        })}
      </GridLayout>
    </Box>
  );
};
